import { createStore } from 'satcheljs';
import { AnonymousCalendarEvent } from '../utils/calendarEventUtils';

export interface CalendarEventDetailsStore {
    calendarEvent: AnonymousCalendarEvent | null;
    eventDetailsFetched: boolean;
}

const calendarEventDetailsStore: CalendarEventDetailsStore = {
    calendarEvent: null,
    eventDetailsFetched: false,
};

export const getCalendarEventDetailsStore = createStore<CalendarEventDetailsStore>(
    'CalendarEventDetailsStore',
    calendarEventDetailsStore
);
